module.exports = __webpack_public_path__ + "img/marie-keating-logo.2bf598f5.png";